export const ServerErrorMessage = error => {
  if (!error.response) {
    return {
      title: "ERROR",
      message: error ? error.message : "Se ha producido un error"
    };
  }

  if (error.response.status === 400) {
    return {
      title: "PETICION INVALIDA",
      message: error.response.data && error.response.data.message ? error.response.data.message : error.message,
      code: error.response.status
    };
  }

  if (error.response.status === 401) {
    return {
      title: "USUARIO NO AUTORIZADO",
      message: error.response.data && error.response.data.message ? error.response.data.message : error.message,
      code: error.response.status
    };
  }

  if (error.response.status === 404) {
    return {
      title: "ERROR SERVIDOR",
      message: error.response.data && error.response.data.message ? error.response.data.Message : error.message,
      code: error.response.status
    };
  }

  if (error.response.status === 500) {
    return {
      title: "ERROR SERVIDOR",
      message:
        error.response.data.message //&& error.response.data.ExceptionMessage
          ? `${error.response.data.message}`//`${error.response.data.ExceptionType}\n${error.response.data.ExceptionMessage}`
          : error.message,
      code: error.response.status
    };
  }
};
